











































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Resources extends Vue {
  calendlyLink = window.calendlyLink;
}
